import { useReadQuery } from '@apollo/client';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { StickyTabNav } from '@synoptic/ui-kit/tab-nav/sticky-tab-nav.tsx';
import { Suspense } from 'react';
import { ClientLoaderFunction, Outlet } from 'react-router';
import { ErrorPage } from '@/components/error-page/error-page.tsx';
import { Page, PageContent } from '@/components/layout/page.tsx';
import { PageHeaderSearch } from '@/components/page-header/page-header-search.tsx';
import { headerTitle } from '@/components/page-header/page-header.css.ts';
import { PageHeader } from '@/components/page-header/page-header.tsx';
import { TabLink } from '@/components/tab-link.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { profileLoader, useProfileLoaderData } from './loader.ts';
import { profileNav, profilePageHeader } from './page.css.ts';
import { ProfileCard } from './profile-card/profile-card.tsx';

export const clientLoader = profileLoader;
(clientLoader as ClientLoaderFunction).hydrate = true;

export const ErrorBoundary = ErrorPage;

export const action = () => new Response(null, { status: 404 });

const HeaderTitle = () => {
  const { profileQueryRef } = useProfileLoaderData();
  // TODO: read fragment instead. In most cases we already have fullname in cache
  const {
    data: { user },
  } = useReadQuery(profileQueryRef);

  return (
    <span className={headerTitle}>{user ? user.fullName : 'Not found'}</span>
  );
};

export const ProfileContent = () => {
  const isTablet = useIsTablet();
  const { profileQueryRef } = useProfileLoaderData();
  const {
    data: { user },
  } = useReadQuery(profileQueryRef);

  if (!user) return null;

  return (
    <>
      <StickyTabNav className={profileNav} size={isTablet ? 'large' : 'small'}>
        <TabLink end to={paths.makeUser(user.username)} preventScrollReset>
          Data streams
        </TabLink>
      </StickyTabNav>

      <Outlet />
    </>
  );
};

export default function ProfilePage() {
  return (
    <Page>
      <PageHeader>
        <div className={profilePageHeader}>
          <Suspense fallback={null}>
            <HeaderTitle />
          </Suspense>
        </div>

        <PageHeaderSearch />
      </PageHeader>

      <PageContent>
        <Suspense fallback={null}>
          <ProfileCard />
        </Suspense>

        <Suspense fallback={null}>
          <ProfileContent />
        </Suspense>
      </PageContent>
    </Page>
  );
}
